import BranchSalesCampaignPanel from './branchSalesCampaignPanel.container';

export default BranchSalesCampaignPanel;